module.exports = __webpack_public_path__ + "img/eight5Red.33018e66.jpg";